"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var React = _interopRequireWildcard(require("react"));
var _Heading = _interopRequireDefault(require("@kiwicom/orbit-components/lib/Heading"));
var _Text = _interopRequireDefault(require("@kiwicom/orbit-components/lib/Text"));
var _Stack = _interopRequireDefault(require("@kiwicom/orbit-components/lib/Stack"));
var _LoggedPanelLinks2 = _interopRequireDefault(require("./LoggedPanelLinks"));
var _ProfileImage2 = _interopRequireDefault(require("../../components/ProfileImage"));
var _SidePanelQrBanner = _interopRequireDefault(require("../SidePanelQrBanner"));
var _Media2 = _interopRequireDefault(require("../../components/Media"));
var _useGetUser = _interopRequireDefault(require("../../components/useGetUser"));
var _context = require("../../../../services/brand/context");
var _jsxRuntime = require("react/jsx-runtime");
var _ProfileImage, _Media, _LoggedPanelLinks;
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function (e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != typeof e && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && Object.prototype.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n.default = e, t && t.set(e, n), n; }
const LoggedPanelTop = () => {
  var _user$displayName, _user$email, _user$events, _user$events2;
  const user = (0, _useGetUser.default)();
  const name = (_user$displayName = user === null || user === void 0 ? void 0 : user.displayName) !== null && _user$displayName !== void 0 ? _user$displayName : "";
  const email = (_user$email = user === null || user === void 0 ? void 0 : user.email) !== null && _user$email !== void 0 ? _user$email : "";
  const {
    id: brandId
  } = (0, _context.useBrand)();
  const mobileAppUsed = (user === null || user === void 0 ? void 0 : (_user$events = user.events) === null || _user$events === void 0 ? void 0 : _user$events.androidUsed) != null || (user === null || user === void 0 ? void 0 : (_user$events2 = user.events) === null || _user$events2 === void 0 ? void 0 : _user$events2.iosUsed) != null;
  return /*#__PURE__*/(0, _jsxRuntime.jsxs)(_jsxRuntime.Fragment, {
    children: [/*#__PURE__*/(0, _jsxRuntime.jsxs)(_Stack.default, {
      direction: "row",
      spaceAfter: "largest",
      children: [_ProfileImage || (_ProfileImage = /*#__PURE__*/(0, _jsxRuntime.jsx)(_ProfileImage2.default, {
        imgSize: "large"
      })), /*#__PURE__*/(0, _jsxRuntime.jsxs)(_Stack.default, {
        spacing: "XXSmall",
        children: [/*#__PURE__*/(0, _jsxRuntime.jsx)(_Heading.default, {
          as: "h2",
          type: "title2",
          spaceAfter: "none",
          children: name
        }), /*#__PURE__*/(0, _jsxRuntime.jsx)(_Text.default, {
          type: "secondary",
          children: email
        })]
      })]
    }), !mobileAppUsed && brandId === "kiwicom" && (_Media || (_Media = /*#__PURE__*/(0, _jsxRuntime.jsx)(_Media2.default, {
      greaterThanOrEqual: "largeMobile",
      children: /*#__PURE__*/(0, _jsxRuntime.jsx)(_SidePanelQrBanner.default, {})
    }))), _LoggedPanelLinks || (_LoggedPanelLinks = /*#__PURE__*/(0, _jsxRuntime.jsx)(_LoggedPanelLinks2.default, {}))]
  });
};
var _default = exports.default = LoggedPanelTop;